import { createFileRoute } from "@tanstack/react-router";
import { SecretDetail } from "../../features/storage/secret-detail";

export const Route = createFileRoute("/_authed/$org/$project/secrets/$name")({ component: SecretPage });

function SecretPage() {
  const { org, project, name } = Route.useParams();
  return <SecretDetail scope={{ org, project }} name={name} />;
}
